export const DISABLED = 'DISABLED';
export const ADTECH = 'ADTECH';
export const SCRIPT = 'SCRIPT';
export const SCRIPT_RAW = 'SCRIPT_RAW';
export const DOUBLECLICK = 'DOUBLECLICK';
export const DOUBLECLICK_ES = 'DOUBLECLICK_ES';
export const ENSIGHTEN = 'ENSIGHTEN';

export const DART = 'DART'; // unused I think
